module.exports = require('./helpers/bundle-url').getBundleURL('dE9Yt') + "logo-dark.eefe0b7f.svg";